<div class="transaction-details-container">
  <div class="header">
    <div class="header-title">
      <i class="fa-solid fa-globe header-domain-icon"></i>
      <span class="domain-name">{{ domain }}</span>
    </div>
    <span class="header-subtitle" *ngIf="!isLoading">
      {{ records.length }} certificate record{{ records.length !== 1 ? 's' : '' }} saved from Certificate Transparency logs.
    </span>
    <div class="actions">
      <button type="button" class="filter-button secondary-button" (click)="goBack()">
        <i class="fa-solid fa-arrow-left" style="margin-right: 8px;"></i>
        <span>Back to Domains</span>
      </button>
    </div>
  </div>

  <div class="table-container">
    <div *ngIf="isLoading" class="no-transactions-message">Loading certificate records...</div>

    <table *ngIf="!isLoading" class="transactions-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-calendar-check th-icon"></i>
              <span>Not Before</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-clock th-icon"></i>
              <span>Days Remaining</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-certificate th-icon"></i>
              <span>Common Name</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-shield-halved th-icon"></i>
              <span>Risk Level</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-list th-icon"></i>
              <span>Matching SANs</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-gears th-icon"></i>
              <span>Actions</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="paginatedRecords.length > 0; else noRecords">
          <tr *ngFor="let cert of paginatedRecords; let i = index">
            <td style="opacity: 0.9; font-size: 14px; white-space: nowrap;">
              {{ cert.notBefore | date: 'MMM dd, yyyy' }}
            </td>
            <td>
              <span class="days-badge" [ngClass]="getDaysClass(cert.notAfter)">
                {{ getDaysRemaining(cert.notAfter) < 0 ? 'Expired' : getDaysRemaining(cert.notAfter) + 'd' }}
              </span>
            </td>
            <td style="font-weight: 500;">{{ cert.commonName }}</td>
            <td>
              <span class="risk-badge" [ngClass]="getRiskClass(cert.riskLevel)">
                {{ cert.riskLevel || 'LOW' }}
              </span>
            </td>
            <td class="sans-cell">
              <ng-container *ngFor="let san of cert.dnsNames?.slice(0, 3)">
                <span class="san-chip">{{ san }}</span>
              </ng-container>
              <span *ngIf="cert.dnsNames?.length > 3" class="san-chip san-more">
                +{{ cert.dnsNames.length - 3 }} more
              </span>
            </td>
            <td>
              <div class="menu-wrapper">
                <button class="action-button dots-button" (click)="toggleMenu(i, $event)" title="Options">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <div class="dropdown-menu" *ngIf="openMenuIndex === i">
                  <button class="dropdown-item" (click)="openPopup(cert); openMenuIndex = null">
                    <i class="fa-solid fa-eye"></i>
                    <span>View details</span>
                  </button>
                  <button *ngIf="isExpired(cert)" class="dropdown-item dropdown-item--warning" (click)="renewCertificate(cert)">
                    <i class="fa-solid fa-rotate"></i>
                    <span>Renew certificate</span>
                  </button>
                  <button *ngIf="!isSslInstalled(cert)" class="dropdown-item dropdown-item--primary" (click)="installCertificate(cert)">
                    <i class="fa-solid fa-lock"></i>
                    <span>Install certificate</span>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
        <ng-template #noRecords>
          <tr>
            <td colspan="6" class="no-transactions-message">{{ noRecordsMessage }}</td>
          </tr>
        </ng-template>
      </tbody>
    </table>

    <div class="pagination-container" *ngIf="totalPages > 1">
      <button class="pagination-button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
      <button class="pagination-button" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>

<!-- Certificate Detail Popup -->
<div class="popup-overlay" *ngIf="selectedRecord" (click)="closePopup()">
  <div class="popup-card" (click)="$event.stopPropagation()">

    <!-- Popup Header -->
    <div class="popup-header">
      <div class="popup-title">
        <i class="fa-solid fa-certificate popup-title-icon"></i>
        <span>Certificate Details</span>
      </div>
      <button class="popup-close" (click)="closePopup()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Risk Banner -->
    <div class="popup-risk-banner" [ngClass]="getRiskClass(selectedRecord.riskLevel)">
      <i class="fa-solid fa-shield-halved"></i>
      <span>Risk Level: <strong>{{ selectedRecord.riskLevel || 'LOW' }}</strong></span>
    </div>

    <div class="popup-body">

      <!-- Certificate Info Section -->
      <div class="popup-section">
        <div class="popup-section-title">
          <i class="fa-solid fa-id-card"></i>
          <span>Certificate Information</span>
        </div>
        <div class="popup-grid">
          <div class="popup-field">
            <span class="field-label">Common Name</span>
            <span class="field-value">{{ selectedRecord.commonName }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Serial Number</span>
            <span class="field-value mono">{{ selectedRecord.serialNumber }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Issuer Organization</span>
            <span class="field-value">{{ selectedRecord.issuerOrganization || '—' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Issuer Common Name</span>
            <span class="field-value">{{ selectedRecord.issuerCommonName || '—' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Wildcard</span>
            <span class="field-value">
              <span class="bool-badge" [ngClass]="selectedRecord.isWildcard ? 'bool-yes' : 'bool-no'">
                {{ selectedRecord.isWildcard ? 'Yes' : 'No' }}
              </span>
            </span>
          </div>
          <div class="popup-field">
            <span class="field-label">Pre-certificate</span>
            <span class="field-value">
              <span class="bool-badge" [ngClass]="selectedRecord.isPrecert ? 'bool-yes' : 'bool-no'">
                {{ selectedRecord.isPrecert ? 'Yes' : 'No' }}
              </span>
            </span>
          </div>
        </div>
      </div>

      <!-- Validity Section -->
      <div class="popup-section">
        <div class="popup-section-title">
          <i class="fa-solid fa-calendar-days"></i>
          <span>Validity Period</span>
        </div>
        <div class="popup-grid">
          <div class="popup-field">
            <span class="field-label">Not Before</span>
            <span class="field-value">{{ selectedRecord.notBefore | date: 'MMM dd, yyyy – HH:mm:ss' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Not After (Expiry)</span>
            <span class="field-value">{{ selectedRecord.notAfter | date: 'MMM dd, yyyy – HH:mm:ss' }}</span>
          </div>
          <div class="popup-field">
            <span class="field-label">Days Remaining</span>
            <span class="field-value">
              <span class="days-badge" [ngClass]="getDaysClass(selectedRecord.notAfter)">
                {{ getDaysRemaining(selectedRecord.notAfter) < 0 ? 'Expired' : getDaysRemaining(selectedRecord.notAfter) + ' days' }}
              </span>
            </span>
          </div>
          <div class="popup-field">
            <span class="field-label">Inserted Time</span>
            <span class="field-value">{{ selectedRecord.insertedTime | date: 'MMM dd, yyyy – HH:mm:ss' }}</span>
          </div>
        </div>
      </div>

      <!-- DNS Names Section -->
      <div class="popup-section">
        <div class="popup-section-title">
          <i class="fa-solid fa-sitemap"></i>
          <span>DNS Names / SANs ({{ selectedRecord.dnsNames?.length || 0 }})</span>
        </div>
        <div class="dns-list">
          <span *ngFor="let san of selectedRecord.dnsNames" class="san-chip">{{ san }}</span>
          <span *ngIf="!selectedRecord.dnsNames?.length" style="opacity: 0.5; font-size: 14px;">None</span>
        </div>
      </div>

      <!-- TLS Section -->
      <div class="popup-section" *ngIf="selectedRecord.tls?.length">
        <div class="popup-section-title">
          <i class="fa-solid fa-lock"></i>
          <span>TLS Version Support</span>
        </div>
        <div class="tls-grid">
          <div class="tls-row" *ngFor="let t of selectedRecord.tls">
            <span class="tls-version">{{ t.version }}</span>
            <span class="tls-status-badge" [ngClass]="getTlsClass(t.supported)">
              <i class="fa-solid" [ngClass]="t.supported ? 'fa-check' : 'fa-xmark'" style="margin-right: 5px;"></i>
              {{ t.supported ? 'Supported' : 'Not Supported' }}
            </span>
            <span class="tls-warning" *ngIf="t.supported && (t.version === 'TLSv1' || t.version === 'TLSv1.1')">
              <i class="fa-solid fa-triangle-exclamation"></i> Insecure
            </span>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
